export enum EPendoTrackEvent {
  USER_LOGGED_IN = 'user.logged_in',
}

/**
 * Custom interface documenting the `pendo` global object and is NOT exhaustive.
 * It leverages TypeScript to enforce how _we_ use the object, and is NOT an
 * attempt to duplicate or replace Pendo's documentation.
 *
 * @see <https://agent.pendo.io>
 */
export interface IPendo {
  /** @see <https://agent.pendo.io/public/Agent#initializeoptions> */
  initialize :(options :object) => void;
  /** @see <https://agent.pendo.io/public/Agent#isready--boolean> */
  isReady :() => boolean;
  /**
   * @see <https://agent.pendo.io/track-events>
   * @see <https://agent.pendo.io/public/Events#trackname-props>
   * @see <https://support.pendo.io/hc/en-us/articles/360032294151-Track-Events>
   */
  track :(name :EPendoTrackEvent, props ?:Record<string, string>) => void;
}
